import { useQuery } from '@tanstack/react-query';
import instance, { type UicPermissionsResponse } from '@Apis/V1/instance';

/**
 * Custom hook to fetch user permissions from UIC API
 *
 * @returns Query result with permissions data and loading/error states
 */
export const useUicPermissions = () => {
  return useQuery<UicPermissionsResponse>({
    queryKey: ['uicPermissions'],
    queryFn: () => instance.getUicPermissions(),
    // Cache for 10 minutes - permissions don't change frequently
    staleTime: 5 * 60 * 1000,
    // Retry once on failure
    retry: 1,
    // Don't refetch on window focus to avoid unnecessary API calls
    refetchOnWindowFocus: false,
  });
};

/**
 * Helper function to check if user has manageTrials permission
 *
 * @param permissionsData - The permissions response data
 * @returns boolean indicating if user has permission (1 = has permission, 0 or undefined = no permission)
 */
export const hasManageTrialsPermission = (
  permissionsData?: UicPermissionsResponse
): boolean => {
  return permissionsData?.permissions?.visionOneTrials?.manageTrials === 1;
};

export const creditOneConsumptionFeatureShow = (
  permissionsData?: UicPermissionsResponse
): boolean => {
  return permissionsData?.flagsState?.['credit-one-consumption-model'] === 1;
};
